import React from "react";

const ExpertiseGrid = () => {
  return (
    <div className="bg-gray-white cursor-default grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 2xl:mx-36 2xl:py-36  gap-8 font-inter ">
      {/* deadzone start 1 */}
      <div className="hidden  "></div>
      {/* expertise 1 */}
      <div className="bg-blue-effect text-gray-white flex flex-col justify-center  pl-8  text-left relative h-32 md:h-36 w-80  justify-self-center 2xl:justify-self-end transition ease-in-out delay-50 hover:-translate-y-1 hover:scale-110 duration-100">
        <div className="absolute top-4 left-8">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="24"
            height="24"
          >
            <path
              fill="#F0F0F0"
              d="M20.16,5A6.29,6.29,0,0,0,12,4.36a6.27,6.27,0,0,0-8.16,9.48l6.21,6.22a2.78,2.78,0,0,0,3.9,0l6.21-6.22A6.27,6.27,0,0,0,20.16,5Zm-1.41,7.46-6.21,6.21a.76.76,0,0,1-1.08,0L5.25,12.43a4.29,4.29,0,0,1,0-6,4.27,4.27,0,0,1,6,0,1,1,0,0,0,1.42,0,4.27,4.27,0,0,1,6,0A4.29,4.29,0,0,1,18.75,12.43Z"
            />
          </svg>
        </div>
        <div className="text-4xl font-semibold">Familie</div>
      </div>

      {/* expertise 2 */}
      <div className="bg-blue-effect text-gray-white flex flex-col justify-center  pl-8  text-left relative h-32  md:h-36 w-80  justify-self-center">
        <div className="absolute top-4 left-8">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="24"
            height="24"
          >
            <path
              fill="#F0F0F0"
              d="M19,9.5h-.32L17.43,6.38A3,3,0,0,0,14.65,4.5h-6A3,3,0,0,0,5.7,6.91L5.18,9.5H5a3,3,0,0,0-3,3v3a1,1,0,0,0,1,1H4a3,3,0,0,0,6,0h4a3,3,0,0,0,6,0h1a1,1,0,0,0,1-1v-3A3,3,0,0,0,19,9.5Zm-6-3h1.65a1,1,0,0,1,.92.63l.95,2.37H13Zm-5.34.8a1,1,0,0,1,1-.8H11v3H7.22ZM7,17.5a1,1,0,1,1,1-1A1,1,0,0,1,7,17.5Zm10,0a1,1,0,1,1,1-1A1,1,0,0,1,17,17.5Zm3-3h-.78a3,3,0,0,0-4.44,0H9.22a3,3,0,0,0-4.44,0H4v-2a1,1,0,0,1,1-1H19a1,1,0,0,1,1,1Z"
            />
          </svg>
        </div>
        <div className="text-4xl font-semibold">Verkeer</div>
      </div>

      {/* expertise 3 */}
      <div className="bg-black-effect text-gray-white flex flex-col justify-center  pl-8  text-left relative h-32 md:h-36 w-80  justify-self-center 2xl:justify-self-start">
        <div className="absolute top-4 left-8">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            data-name="Layer 1"
            viewBox="0 0 100 100"
            width="24"
            height="24"
          >
            <path
              fill="#F0F0F0"
              d="M28,41c0,.13,0,.22,0,.32s0,.16,0,.3l.57,0H32A1.85,1.85,0,0,1,33.94,43a2.69,2.69,0,0,1,.07.7c0,1.46,0,2.92,0,4.38v.57A19.3,19.3,0,1,1,8.38,71.15a18.71,18.71,0,0,1,1.74-13.48,19.2,19.2,0,0,1,10.16-9V48c0-1.46,0-2.92,0-4.38a1.92,1.92,0,0,1,2-2h4l0-.68a4.13,4.13,0,0,1-1.23-4.1,7,7,0,0,1,1.25-3.15,4.93,4.93,0,0,1,1.44-1.29C26.93,29.83,29,25.87,32,25.16c-.4-3,2.51-6.24,5-6.47.61-2.32,2.4-3.29,4.51-3.85a6.52,6.52,0,0,1,1.4-.14,3.45,3.45,0,0,1,2.35.73,5.31,5.31,0,0,1,4.15-.59A5.84,5.84,0,0,1,53.05,17c.4-.17.76-.37,1.14-.5a6.19,6.19,0,0,1,4,.17,8.08,8.08,0,0,1,1.53.76,3.25,3.25,0,0,1,1.63,2.37c.29.07.58.11.86.19a5.49,5.49,0,0,1,2,1.1,6.77,6.77,0,0,1,2.22,3.15,3,3,0,0,1-.11,2.52l.41.88L70.41,26a2,2,0,0,1,1.2-.22A1.92,1.92,0,0,1,73.1,27Q74,29.1,75,31.2c0,.13.11.25.18.41a19.23,19.23,0,0,1,15.11,6.16,18.6,18.6,0,0,1,5,10.86,19.28,19.28,0,0,1-34.53,13.9,18.64,18.64,0,0,1-3.85-13,19.12,19.12,0,0,1,5.66-12.31l-.82-1.86c-.39-.9-.77-1.81-1.2-2.7a2,2,0,0,1,1.09-2.76c1-.4,2-.88,3-1.32l.59-.3L65,27.59a5.28,5.28,0,0,1-3.84-1.8,6.19,6.19,0,0,1-1.86-3.87,6.85,6.85,0,0,1-6.55-2.2c-2.22,1.5-5.87.63-7.6-1.24a6.88,6.88,0,0,1-2.73,1.87,6.76,6.76,0,0,1-3.29.37,6.19,6.19,0,0,1-1.55,3.8,5.68,5.68,0,0,1-3.38,2.1,6.72,6.72,0,0,1-3.68,6.79,5.87,5.87,0,0,1,.06,4.21A5.35,5.35,0,0,1,28,41ZM14.34,66.71A12.81,12.81,0,1,0,27.18,53.9,12.76,12.76,0,0,0,14.34,66.71ZM76.16,38.08A12.82,12.82,0,1,0,89,50.53,12.84,12.84,0,0,0,76.16,38.08ZM32.51,28.37c0-.5,0-.9-.37-1.12a1,1,0,0,0-1.05.19,3.9,3.9,0,0,0-1.77,3,.94.94,0,0,0,.36,1,.9.9,0,0,0,1-.13A3.89,3.89,0,0,0,32.51,28.37Zm32.31-3.51a1.71,1.71,0,0,0,0-.36,3.8,3.8,0,0,0-2.56-2.71c-.76-.24-1.19.17-1,1a3.64,3.64,0,0,0,1.16,2,3.14,3.14,0,0,0,1.57.89C64.5,25.76,64.81,25.51,64.82,24.86Zm-15.2-6A2.51,2.51,0,0,0,51,18.6a.64.64,0,0,0,.24-1,1.8,1.8,0,0,0-.44-.47,3.85,3.85,0,0,0-3.22-.77c-.41.08-.85.2-1,.67s.23.74.54,1A3.9,3.9,0,0,0,49.62,18.88ZM33.75,23.76c0,.78.31,1,1,.89a1.82,1.82,0,0,0,.39-.14,4,4,0,0,0,2.09-2.64,1,1,0,0,0-.2-1.1c-.35-.29-.76-.13-1.11,0a4,4,0,0,0-2.12,2.56A2.3,2.3,0,0,0,33.75,23.76Zm23.77-3.27a9,9,0,0,0,1.19-.27c.59-.23.68-.68.31-1.18a1.37,1.37,0,0,0-.2-.22A3.79,3.79,0,0,0,55.25,18c-.88.22-1,.83-.38,1.47a3.53,3.53,0,0,0,.66.49A4.68,4.68,0,0,0,57.52,20.49ZM42.44,16.3a4.18,4.18,0,0,0-2.65,1,3.27,3.27,0,0,0-.58.8.56.56,0,0,0,.28.8,1.46,1.46,0,0,0,.5.16,3.85,3.85,0,0,0,3.4-1.23,1.46,1.46,0,0,0,.29-.44.64.64,0,0,0-.39-.95A6.11,6.11,0,0,0,42.44,16.3ZM29.31,35.82a4.76,4.76,0,0,0-.08-.68c-.08-.37-.21-.76-.63-.86s-.66.18-.92.43l-.12.13a4,4,0,0,0-.86,3.21c.06.39.18.8.62.92s.72-.16,1-.44A3.94,3.94,0,0,0,29.31,35.82Zm38.74-4.3c.49-.81.5-1.33.08-1.82a1.27,1.27,0,0,0-1.45-.35,1.31,1.31,0,0,0-.81,1.25c0,.66.44,1,1.43,1.28.14.3.29.62.43.94s.2.38.42.34a1.77,1.77,0,0,0,.46-.31ZM27.5,45.74c.83-.57,1.05-1,.87-1.64a1.31,1.31,0,0,0-1.22-1A1.25,1.25,0,0,0,26,44a1.59,1.59,0,0,0,0,.75,1.21,1.21,0,0,0,.8.88,7.72,7.72,0,0,0,.15,1.59l.62,0Z"
            />
          </svg>
        </div>
        <div className="text-4xl font-semibold">Misdrijf</div>
      </div>

      {/* deadzone einde 1 */}
      {/* <div className="hidden "></div> */}
      {/* rij 2 */}

      {/* deadzone start 2 */}

      {/* expertise 4 */}

      <div className="bg-black-effect text-gray-white flex flex-col justify-center  pl-8  text-left relative h-32 md:h-36 w-80 justify-self-center 2xl:justify-self-end">
        <div className="absolute top-4 left-8">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            data-name="Layer 1"
            viewBox="0 0 24 24"
            width="24"
            height="24"
          >
            <path
              fill="#F0F0F0"
              d="M20,13.17V13a8,8,0,0,0-2.42-5.74A7.84,7.84,0,0,0,14.4,5.38l-.05,0A8.24,8.24,0,0,0,11.76,5,8.21,8.21,0,0,0,4,13.17,3,3,0,0,0,5,19H19a3,3,0,0,0,1-5.83ZM19,17H5a1,1,0,0,1,0-2H7a1,1,0,0,0,0-2H6A6.41,6.41,0,0,1,9,7.85V11a1,1,0,0,0,2,0V7.09A7.34,7.34,0,0,1,11.82,7H12a5.56,5.56,0,0,1,1,.1V11a1,1,0,0,0,2,0V7.82a6.65,6.65,0,0,1,1.18.87A6,6,0,0,1,18,13H17a1,1,0,0,0,0,2h2a1,1,0,0,1,0,2Z"
            />
          </svg>
        </div>

        <div className="text-4xl font-semibold">Bouw</div>
      </div>
      {/* experise 5 */}
      <div className="bg-blue-effect text-gray-white flex flex-col justify-center  pl-8  text-left relative h-32 md:h-36 w-80 justify-self-center">
        <div className="absolute top-4 left-8">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="ionicon"
            viewBox="0 0 512 512"
            height="24"
            width="24"
            
          >
            <title>Alert Circle</title>
            <path
              d="M448 256c0-106-86-192-192-192S64 150 64 256s86 192 192 192 192-86 192-192z"
              fill="none"
              stroke="#F0F0F0"
              stroke-miterlimit="10"
              stroke-width="32"
            />
            <path
              d="M250.26 166.05L256 288l5.73-121.95a5.74 5.74 0 00-5.79-6h0a5.74 5.74 0 00-5.68 6z"
              fill="#F0F0F0"
              stroke="#F0F0F0"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="32"
            />
            <path
              fill="#F0F0F0"
              d="M256 367.91a20 20 0 1120-20 20 20 0 01-20 20z"
            />
          </svg>
        </div>
        <div className="text-4xl font-semibold">Invordering</div>
      </div>

      {/* expertise 6 */}
      <div className="bg-blue-effect text-gray-white  flex flex-col justify-center  pl-8  text-left relative h-32 md:h-36 w-80 justify-self-center 2xl:justify-self-start">
        <div className="absolute top-4 left-8">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            data-name="Layer 2"
            viewBox="0 0 32 32"
            width="24"
            height="24"
          >
            <path
              fill="#F0F0F0"
              d="M30 15a1 1 0 0 1-.58-.19L16 5.23 2.58 14.81a1 1 0 0 1-1.16-1.62l14-10a1 1 0 0 1 1.16 0l14 10A1 1 0 0 1 30 15zM5 9A1 1 0 0 1 4 8V4A1 1 0 0 1 5 3H9A1 1 0 0 1 9 5H6V8A1 1 0 0 1 5 9z"
            />
            <path
              fill="#F0F0F0"
              d="M25,29H20a1,1,0,0,1-1-1V21H13v7a1,1,0,0,1-1,1H7a3,3,0,0,1-3-3V16a1,1,0,0,1,2,0V26a1,1,0,0,0,1,1h4V20a1,1,0,0,1,1-1h8a1,1,0,0,1,1,1v7h4a1,1,0,0,0,1-1V16a1,1,0,0,1,2,0V26A3,3,0,0,1,25,29Z"
            />
          </svg>
        </div>
        <div className="text-4xl font-semibold">Huur</div>
      </div>

      {/* deadzone einde 2 */}

      {/* rij "3" */}
      {/* deadzone start 3 */}

      {/* expertise 7 */}
      <div className="bg-black-effect text-gray-white flex flex-col justify-center  pl-8  text-left relative h-32 md:h-36 w-80 justify-self-center 2xl:justify-self-end">
        <div className="absolute top-4 left-8">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 64 64"
          >
            <path
              fill="#F0F0F0"
              d="M52 64c2.206 0 4-1.794 4-4V4c0-2.206-1.794-4-4-4H26c-1.638 0-3.668.841-4.828 2L10 13.171C8.841 14.33 8 16.36 8 18v42c0 2.206 1.794 4 4 4h40zm0-60v56H12V18h10c2.206 0 4-1.794 4-4V4h26zM22 6.828V14h-7.172L22 6.828z"
            />
            <path
              fill="#F0F0F0"
              d="M32 16h12a2 2 0 000-4H32a2 2 0 000 4zM44 22H20a2 2 0 000 4h24a2 2 0 000-4zM44 32H20a2 2 0 000 4h24a2 2 0 000-4zM44 42H20a2 2 0 000 4h24a2 2 0 000-4zM44 52H20a2 2 0 000 4h24a2 2 0 000-4z"
            />
          </svg>
        </div>
        <div className="text-4xl font-semibold">Contracten</div>
      </div>

      {/* expertise 8 */}
      <div className="bg-black-effect text-gray-white flex flex-col justify-center  pl-8  text-left relative h-32 md:h-36 w-80 justify-self-center">
        <div className="absolute top-4 left-8">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            data-name="Layer 1"
            viewBox="0 0 24 24"
            width="24"
            height="24"
          >
            <path
              fill="#F0F0F0"
              d="M8.82,11.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.41,0,1,1,0,0,0,0-1.42A1,1,0,0,0,8.82,11.29Zm2.47,2.48a1,1,0,0,0,0,1.41,1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.41A1,1,0,0,0,11.29,13.77Zm9-10A6,6,0,0,0,12,3.55a6,6,0,0,0-8.24.2h0A6,6,0,0,0,3.57,12,6,6,0,0,0,8,22a5.92,5.92,0,0,0,4-1.55,6,6,0,0,0,8.25-.2A6,6,0,0,0,20.43,12,6,6,0,0,0,20.25,3.75ZM18.83,5.17A4,4,0,0,1,19,10.56L13.44,5A4.07,4.07,0,0,1,18.83,5.17ZM5.17,18.83A4,4,0,0,1,5,13.44l5.6,5.6A4.08,4.08,0,0,1,5.17,18.83Zm13.66,0a4.08,4.08,0,0,1-5.64,0l-8-8a4,4,0,0,1,0-5.64h0a4,4,0,0,1,5.64,0l8,8A4,4,0,0,1,18.83,18.83Zm-5.06-7.54a1,1,0,0,0,0,1.42,1,1,0,0,0,1.41,0,1,1,0,0,0,0-1.42A1,1,0,0,0,13.77,11.29ZM11.29,8.82a1,1,0,0,0,0,1.41,1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.41A1,1,0,0,0,11.29,8.82Z"
            />
          </svg>
        </div>
        <div className="text-4xl font-semibold">Schade</div>
      </div>

      {/* experise 9 */}
      <div className="bg-blue-effect text-gray-white flex flex-col justify-center  pl-8  text-left relative h-32 md:h-36 w-80 justify-self-center 2xl:justify-self-start">
        <div className="absolute top-4 left-8">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="24"
            height="24"
          >
            <path
              fill="#F0F0F0"
              d="M6,11a1,1,0,1,0,1,1A1,1,0,0,0,6,11Zm12,0a1,1,0,1,0,1,1A1,1,0,0,0,18,11Zm2-6H4A3,3,0,0,0,1,8v8a3,3,0,0,0,3,3H20a3,3,0,0,0,3-3V8A3,3,0,0,0,20,5Zm1,11a1,1,0,0,1-1,1H4a1,1,0,0,1-1-1V8A1,1,0,0,1,4,7H20a1,1,0,0,1,1,1ZM12,9a3,3,0,1,0,3,3A3,3,0,0,0,12,9Zm0,4a1,1,0,1,1,1-1A1,1,0,0,1,12,13Z"
            />
          </svg>
        </div>
        <div className="text-4xl font-semibold">Erfenis</div>
      </div>

      {/* deadzone einde 3 */}
    </div>
  );
};

export default ExpertiseGrid;
